export const dataHooks = {
  avatarGroupItem: 'avatar-item',
  avatarGroupMoreItem: 'avatar-more-item',
  avatarCore: 'avatar-core',
};
